import React from "react";
import ReactDOM from "react-dom/client"; // Changed this line
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// React 18 syntax
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();